var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('formio-builder-component',{staticClass:"formio-builder-component",attrs:{"formExpansionDefinition":_vm.formDefinition,"createNew":_vm.createNew,"baseOptions":_vm.baseOptions},on:{"close":_vm.closeFormioBuilder}})}
var staticRenderFns = []

export { render, staticRenderFns }